import { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";

export interface User {
  name?: string;
  email?: string;
}

export interface UserContext {
  user?: User;
}

function useUser(): UserContext {
  const { accounts } = useMsal();
  const [user, setUser] = useState<User | undefined>(undefined);

  useEffect(() => {
    setUser({
      name: accounts[0]?.name,
      email: accounts[0]?.username,
    });
  }, [accounts]);

  return {
    user,
  };
}

export default useUser;
